import axiosInstance from '../../utils/axiosConfig';

export const GET_INVESTIGATION = 'GET_INVESTIGATION';
export const GET_INVESTIGATION_BY_ID = 'GET_INVESTIGATION_BY_ID'; // New action type
export const CREATE_INVESTIGATION = 'CREATE_INVESTIGATION';
export const DELETE_INVESTIGATION = 'DELETE_INVESTIGATION';
export const UPDATE_INVESTIGATION = 'UPDATE_INVESTIGATION';

export const CLEAR_SELECTED_INVESTIGATION = 'CLEAR_SELECTED_INVESTIGATION';

const API_URL = process.env.REACT_APP_BACKEND_URL_MS_INVESTIGATION + '/investigation';

// Action to fetch all investigations
export const getAllInvestigation = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(API_URL);
    dispatch({ type: GET_INVESTIGATION, payload: response.data });
  } catch (error) {
    console.error('Error fetching investigations:', error);
  }
};

// Action to fetch an investigation by ID
export const getInvestigationById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${id}`);
    dispatch({ type: GET_INVESTIGATION_BY_ID, payload: response.data });
  } catch (error) {
    console.error('Error fetching investigation by ID:', error);
  }
};

// Action to create a new investigation
export const createInvestigation = (investigation) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(API_URL, investigation);
    dispatch({ type: CREATE_INVESTIGATION, payload: response.data });
    return response.data;
  } catch (error) {
    console.error('Error creating investigation:', error);
  }
};

// Action to update an investigation
export const updateInvestigation = (id, updatedInvestigation) => async (dispatch) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${id}`, updatedInvestigation);
    dispatch({ type: UPDATE_INVESTIGATION, payload: response.data });
  } catch (error) {
    console.error('Error updating investigation:', error);
  }
};

// Action to delete an investigation
export const deleteInvestigation = (id) => async (dispatch) => {
  try {
    await axiosInstance.delete(`${API_URL}/${id}`);
    dispatch({ type: DELETE_INVESTIGATION, payload: id });
  } catch (error) {
    console.error('Error deleting investigation:', error);
  }
};

// Action to clear the selected investigation
export const clearSelectedInvestigation = () => ({
  type: CLEAR_SELECTED_INVESTIGATION,
});
